<template>
  <PeriodsFetcher :store-id="storeId" :lines="3">
    <template #default="{ data }">
      <b-button
        v-for="option in parsePeriods(data)"
        :key="option.value"
        :variant="getVariant(option.value)"
        block
        :active="isActive(option.value)"
        :disabled="isActive(option.value)"
        @click="onClick(option.value)"
      >
        <span v-if="isActive(option.value)" class="fas fa-check mr-1" />
        {{ option.text }}
      </b-button>
    </template>
  </PeriodsFetcher>
</template>

<script>
import { parsePeriodRadioGroupOptions } from '@/helpers/periods'
import PeriodsFetcher from './PeriodsFetcher'
import { formatCurrency } from '@/helpers/numbers'

export default {
  name: 'PeriodRadioGroup',
  components: {
    PeriodsFetcher
  },
  filters: {
    formatCurrency
  },
  props: {
    value: {
      type: Number,
      default: null
    },
    validation: {
      type: Object,
      default: () => ({})
    },
    storeId: {
      type: [String, Number],
      default: null
    }
  },
  computed: {
    periodId: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    // Retorna somente opções ativas, já ordenadas e formatadas
    parsePeriods(periods) {
      return parsePeriodRadioGroupOptions(periods)
    },
    // Verifica se um value corresponde ao período selecionado
    isActive(value) {
      return this.periodId === value
    },
    // Define o variant do botão conforme ativo ou não
    getVariant(value) {
      return this.isActive(value) ? 'primary' : 'outline-primary'
    },
    // Trata clique, atualizando o v-model com o novo período
    onClick(value) {
      this.periodId = value
    },
    // Caso precise da função reduce em outras implementações
    reduce: ({ code }) => code
  }
}
</script>
